import { apiWrapper } from "apis/CommonApi";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "utils/store";
import * as fireonApi from "../../apis/FireOnApi";
import FireOnToolbar from "./FireOnToolbar";

//소방 시설 현황
export default function FireEquipmentStatusComponent(props) {
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    return (
        <>
            <div className="viewBoard fireOnBoard tableBoard">
                <TopBoard currentDateTime={props.currentDateTime} />
                <MidBoard />
                <TableBoard />
                <FireOnToolbar item="소방시설현황" buildingName={buildingName} serialNumber={serialNumber} dei={dei} />
            </div>
            <Toolbar />
        </>
    );
}

const TopBoard = ({ currentDateTime }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { store: { userName } } = useAppContext();
    const location = useLocation();

    const handleGoBack = () => {
        navigate(`/fire-on/alarm-monitor/${id}`, location.state);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo" /> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <a className="set_contr" href="#">
                            <img src="/images/my_btn_mb_w.png" alt="" />
                        </a>
                    </div>
                </div>
            </div>

            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">소방시설현황</p>
                </div>
                <div className="wrap_right pc">
                    <div className="wrap_userBox">
                        <div className="wrap_userInfo pc">
                            <p className="current_date">{currentDateTime}</p>
                        </div>
                        <p className="user_id">{userName}</p>
                    </div>
                </div>
                <div className="wrap_right mb">
                    <a className="btn_page_left" href="/fireEquipmentStatus_mb.html">
                        <i className="x-icon"></i>
                    </a>
                </div>
            </div >
        </>
    );
};

const MidBoard = () => {
    const location = useLocation();
    const { buildingName } = location.state;

    const handleExportExcel = () => {
        apiWrapper(async () => {
            // const { status, data } = await fireonApi.downloadFireFightingFacilityList();
            // if (status === false) {
            //     alert(`엑셀 저장에 실패하였습니다.\n${data}`);
            // }
        });
    }

    return (
        <div className="mid_board mid_col_board">
            <div className="wrap_mid_le">
                <p className="title_mid">{buildingName}</p>
            </div>
            <div className="wrap_right pc">
                <div className="wrap_item_contr">
                    <button className="btn_contr btn_add" onClick={handleExportExcel} >엑셀</button>
                </div>
            </div>
        </div>
    );
};

const TableBoard = () => {
    const { id } = useParams();
    const itemsPerPage = 100;
    const [dataSource, setDataSource] = useState(null);
    const [previous, setPrevious] = useState(null);
    const [next, setNext] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        getData(1);
    }, []);

    const getData = (page, url = null) => {
        apiWrapper(async () => {
            let result;
            if (url !== null) {
                result = await fireonApi.getFireFightingFacilityListByUrl(url);
            } else {
                result = await fireonApi.getFireFightingFacilityList(id, page, itemsPerPage);
            }

            const { status, data } = result;
            if (status === true) {
                setDataSource(data);

                setPrevious(data.previous);
                setNext(data.next);
                setPage(page);
            } else {
                alert(`${data}`);
            }

        })
    }

    return (
        <div className="table_board fes_table_board">
            <div className="containerTable fireEquipmentTable">
                <ul className="head_table">
                    <li>
                        <input className="all_chk" type="checkbox" />
                    </li>
                    <li><p>관리순번</p></li>
                    <li><p>설비분류</p></li>
                    <li><p>설비명칭</p></li>
                    <li><p>형식승인번호</p></li>
                    <li><p>설비모델명</p></li>
                    <li><p>설비일련번호</p></li>
                    <li><p>설비제원</p></li>
                    <li><p>제조사</p></li>
                    <li><p>제조년월</p></li>
                    <li><p>구입일자</p></li>
                    <li><p>구입가격</p></li>
                    <li><p>구입업체</p></li>
                    <li><p>구입연락처</p></li>
                    <li><p>AS연락처</p></li>
                    <li><p>설비사진</p></li>
                    <li><p>설치일자</p></li>
                    <li><p>설치층</p></li>
                    <li><p>설치업체</p></li>
                    <li><p>설치연락처</p></li>
                    <li><p>운영상태</p></li>
                </ul>

                <div className="body_table">
                    <div className="inner_table_wrap">
                        {dataSource &&
                            dataSource.results.map((equipment, index) => (
                                <div className="wrap_table_item" key={index}>
                                    <div className="inner_table_item table_item_01">
                                        <input className="cont_table_chekbox" type="checkbox" />
                                    </div>
                                    <div className="inner_table_item table_item_02">
                                        <p className="cont_table_item">{equipment.id}</p>
                                    </div>
                                    <div className="inner_table_item table_item_03">
                                        <p className="cont_table_item">{equipment.category}</p>
                                    </div>
                                    <div className="inner_table_item table_item_04">
                                        <p className="cont_table_item">{equipment.name}</p>
                                    </div>
                                    <div className="inner_table_item table_item_05">
                                        <p className="cont_table_item">{equipment.approvalNumber}</p>
                                    </div>
                                    <div className="inner_table_item table_item_06">
                                        <p className="cont_table_item">{equipment.modelName}</p>
                                    </div>
                                    <div className="inner_table_item table_item_07">
                                        <p className="cont_table_item">{equipment.serialNumber}</p>
                                    </div>
                                    <div className="inner_table_item table_item_08">
                                        <p className="cont_table_item">{equipment.specifications}</p>
                                    </div>
                                    <div className="inner_table_item table_item_09">
                                        <p className="cont_table_item">{equipment.manufacturer}</p>
                                    </div>
                                    <div className="inner_table_item table_item_10">
                                        <p className="cont_table_item">{equipment.manufactureDate}</p>
                                    </div>
                                    <div className="inner_table_item table_item_11">
                                        <p className="cont_table_item">{equipment.purchaseDate}</p>
                                    </div>
                                    <div className="inner_table_item table_item_12">
                                        <p className="cont_table_item">{equipment.purchasePrice}</p>
                                    </div>
                                    <div className="inner_table_item table_item_13">
                                        <p className="cont_table_item">{equipment.purchaseCompany}</p>
                                    </div>
                                    <div className="inner_table_item table_item_14">
                                        <p className="cont_table_item">{equipment.purchaseContact}</p>
                                    </div>
                                    <div className="inner_table_item table_item_15">
                                        <p className="cont_table_item">{equipment.asContact}</p>
                                    </div>
                                    <div className="inner_table_item table_item_16">
                                        <p className="cont_table_item">{equipment.photoImage === '' ? '무' : '유'}</p>
                                    </div>
                                    <div className="inner_table_item table_item_17">
                                        <p className="cont_table_item">{equipment.installationDate}</p>
                                    </div>
                                    <div className="inner_table_item table_item_18">
                                        <p className="cont_table_item">{equipment.installationFloor}</p>
                                    </div>
                                    <div className="inner_table_item table_item_19">
                                        <p className="cont_table_item">{equipment.installationCompany}</p>
                                    </div>
                                    <div className="inner_table_item table_item_20">
                                        <p className="cont_table_item">{equipment.installationContact}</p>
                                    </div>
                                    <div className="inner_table_item table_item_21">
                                        <p className="cont_table_item">{equipment.operationalStatus}</p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const Toolbar = () => {
    return (
        <div class="toolbar">
            <div class="wrap_inner">
                <a href="" class="btn_tb btn_tbAdd">선택 삭제</a>
            </div>
        </div>
    );
};